import { createElement } from 'react';
import { b as _objectWithoutPropertiesLoose } from './_rollupPluginBabelHelpers-cb1cd42c.js';
import { useOptions, useProps } from 'reakit-system';
import { useRole } from 'reakit';

function ErrorMessage(_ref) {
  var error = _ref.error,
      unstable_system = _ref.unstable_system,
      htmlProps = _objectWithoutPropertiesLoose(_ref, ["error", "unstable_system"]);

  var options = useOptions("ErrorMessage", {
    error: error,
    unstable_system: unstable_system
  }, htmlProps);
  htmlProps = useProps("ErrorMessage", options, htmlProps);
  htmlProps = useRole(options, htmlProps);
  return /*#__PURE__*/createElement("pre", htmlProps, options.error.toString());
}

export { ErrorMessage };
